import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';

@Component({
  selector: 'app-book-demo',
  templateUrl: './book-demo.component.html',
  styleUrls: ['./book-demo.component.scss']
})
export class BookDemoComponent implements OnInit {

  constructor(
    private titleService: Title,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) { }



  ngOnInit() {
    this.titleService.setTitle('Book a Demo');

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    Calendly.initInlineWidget({
      url: 'https://calendly.com/vocbot-ai/30min',
      parentElement: document.getElementById('calendly-embed'),
      prefill: {},
      utm: {}
    });
    `;
    this.renderer.appendChild(this.elementRef.nativeElement, script);

    setTimeout(() => {
      Aos.init();
    }, 500);
    Aos.refresh();
  }
}
